import styled from 'styled-components';
import { rem } from '@/styles/theme';

interface IProps {
  isDivider?: boolean;
  isBottomLine?: boolean;
}

export const InfoWrapper = styled.dl<IProps>`
  display: flex;
  padding: ${rem(12)} ${rem(18)};
  ${({ isDivider }) =>
    isDivider &&
    `
    padding: ${rem(40)} ${rem(18)} ${rem(12)};
  `}
  gap: ${rem(12)};

  dt {
    min-width: max-content;
    width: 100px;
  }

  dd {
    width: calc(100% - 100px);
    flex-grow: 1;
  }
`;
